import { Copy } from "@/shared/foundation/icons";
import { RobotoButton } from "@/shared/foundation/primitives";

import styles from "./UriCell.module.css";

interface UriCellProps {
  /** The registry URI to show, truncated from the left so its tail stays readable. */
  uri: string;
  /** Copies `uri` to the clipboard and tells the user. */
  onCopy: (uri: string) => void;
}

/**
 * A repository or image URI with a copy button beside it, as both the
 * repository rows and an opened repository's image rows draw it.
 */
export function UriCell({ uri, onCopy }: UriCellProps) {
  return (
    <span className={styles.uriCell}>
      <span className={styles.uriTail} title={uri}>
        <span className={styles.uriTailInner}>{uri}</span>
      </span>
      <RobotoButton
        variant="ghost"
        size="sm"
        className={styles.copyButton}
        icon={<Copy />}
        aria-label={`Copy ${uri}`}
        onClick={(event) => {
          event.stopPropagation();
          onCopy(uri);
        }}
      />
    </span>
  );
}
